import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { asyncActionError } from '../store/actions'
import { httpsCallable } from 'firebase/functions'
import { cloudFunctions } from '../config/firebase'
import { getUserIdToken } from '../store/actions/authActions'
import { updateUserFlags } from '../shared/utility'

async function getUserHasPOS() {
  try {
    let token = await getUserIdToken()
    const result = await httpsCallable(cloudFunctions, 'getConfigurationData')({ user_token: token })
    return ((!!result.data.organizationUUID) || ((!!result.data.uid) && (!!result.data.pos)))
  } catch (error) {
    return false
  }
}

function getUserHasChannels(locations) {
  return locations.filter((loc) => loc.channels?.length > 0).length > 0
}

function getUserHasMenu(menu) {
  return menu.length > 0
}

export const useUserFlags = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.user)
  const { locations } = useSelector((state) => state.location)
  const { menuItems } = useSelector((state) => state.menu)

  useEffect(async () => {
    if (!user) return
    if (!user.hasChannels || !user.hasMenu || !user.hasPOS) {
      const hasChannels = user.hasChannels ? user.hasChannels : getUserHasChannels(locations)
      const hasMenu = user.hasMenu ? user.hasMenu : getUserHasMenu(menuItems)
      const hasPOS = user.hasPOS ? user.hasPOS : await getUserHasPOS()

      const { error } = await updateUserFlags({
        hasChannels,
        hasMenu,
        hasPOS,
      })
      if (error) dispatch(asyncActionError(error))
    }
  }, [user])

  return {
    useUserFlags,
  }
}
